import {XHTTP} from '@/shared/xhttp';
import {DateHelper} from "@/shared/utils";


export class AchatFrais {

	private _id: number;
	private _date: Date = new Date();
	private _description: string;
	private _montantUnitaire: number = 0;
	private _quantite: number = 1;
	private _montant: number = 0;
	private _unite: string;
	private _remarques: string;

	/////////////
	// Getters //
	/////////////

	public get id(): number {
		return this._id;
	}

	public get date(): Date {
		return this._date;
	}

	public get montantUnitaire(): number {
		return this._montantUnitaire;
	}

	public get quantite(): number {
		return this._quantite;
	}

	public get montant(): number {
		return this._montant;
	}

	public get description(): string {
		return this._description;
	}

	public get unite(): string {
		return this._unite;
	}

	public get remarques(): string {
		return this._remarques;
	}

	/////////////
	// Setters //
	/////////////

	public set date(value: Date) {
		this._date = value;
	}

	public set montantUnitaire(value: number) {
		this._montantUnitaire = value;
		this._montant = Math.round((value * this._quantite + Number.EPSILON) * 100) / 100;
	}

	public set quantite(value: number) {
		this._quantite = value;
		this._montant = Math.round((value * this._montantUnitaire + Number.EPSILON) * 100)/ 100;
	}

	public set montant(value: number) {
		this._montant = value;
		this._montantUnitaire = Math.round((value / this._quantite + Number.EPSILON) * 100)/ 100;
	}

	public set description(value: string) {
		this._description = value;
	}

	public set remarques(value: string) {
		this._remarques = value;
	}

	public set unite(value: string) {
		this._unite = value;
	}

	///////////////
	// Serialize //
	///////////////

	public toJSON(): any {
		return {
			id            : this._id,
			date 		: this._date ? DateHelper.toLocalizedString(this._date) : null,
			montantUnitaire       : this._montantUnitaire,
			quantite       : this._quantite,
			montant       : this._montant,
			description : this._description,
			unite : this._unite,
			remarques : this._remarques,
		};
	}

	public fromJSON(data: any): this {
		this._id           = data.id
		this._date         = data.date ? DateHelper.fromLocalizedString(data.date) : null;
		this._montantUnitaire        = data.montantUnitaire;
		this._quantite        = data.quantite;
		this._montant        = data.montant;
		this._remarques	   = data.remarques;
		this._description  = data.description;
		this._unite	   = data.unite;
		return this;
	}
}
